import React from "react";
import { Box, Paper, Typography, Stack, useTheme } from "@mui/material";
import {
  Assessment as AssessmentIcon,
  TrendingDown as LowRiskIcon,
  TrendingFlat as MediumRiskIcon,
  TrendingUp as HighRiskIcon,
} from "@mui/icons-material";
import { getRiskStats } from "../utils/riskUtils";
import { styles } from "../styles/RiskManagement.styles";

const RiskSummary = ({ risks = [], loading = false }) => {
  const theme = useTheme();
  const stats = getRiskStats(risks);

  const displayStat = (value) => {
    if (loading) {
      return "-";
    }
    return value;
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <Paper elevation={0} sx={styles.statsCard}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="600"
                color={theme.customColors.text.strong}
              >
                {displayStat(stats.total)}
              </Typography>
              <Typography
                variant="body2"
                color={theme.customColors.text.secondary}
              >
                Total Risks
              </Typography>
            </Box>
            <AssessmentIcon
              sx={{ color: theme.customColors.icons.primary, fontSize: 24 }}
            />
          </Box>
        </Paper>

        <Paper elevation={0} sx={styles.statsCard}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="600"
                color={theme.customColors.status.success.text}
              >
                {displayStat(stats.low)}
              </Typography>
              <Typography
                variant="body2"
                color={theme.customColors.text.secondary}
              >
                Low Risks
              </Typography>
            </Box>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                backgroundColor: theme.customColors.status.success.main,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LowRiskIcon
                sx={{ color: theme.customColors.button.text, fontSize: 16 }}
              />
            </Box>
          </Box>
        </Paper>

        <Paper elevation={0} sx={styles.statsCard}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="600"
                color={theme.customColors.status.warning.text}
              >
                {displayStat(stats.medium)}
              </Typography>
              <Typography
                variant="body2"
                color={theme.customColors.text.secondary}
              >
                Medium Risks
              </Typography>
            </Box>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                backgroundColor: theme.customColors.status.warning.main,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MediumRiskIcon
                sx={{ color: theme.customColors.button.text, fontSize: 16 }}
              />
            </Box>
          </Box>
        </Paper>

        <Paper elevation={0} sx={styles.statsCard}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="600"
                color={theme.customColors.status.error.text}
              >
                {displayStat(stats.high)}
              </Typography>
              <Typography
                variant="body2"
                color={theme.customColors.text.secondary}
              >
                High Risks
              </Typography>
            </Box>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                backgroundColor: theme.customColors.status.error.main,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <HighRiskIcon
                sx={{ color: theme.customColors.button.text, fontSize: 16 }}
              />
            </Box>
          </Box>
        </Paper>
      </Stack>
    </Box>
  );
};

export default RiskSummary;
